import React, { Component } from 'react';
import { StyleSheet, View, Text, Image } from 'react-native';
import images from "../../images/ImagesControl";

class Faq1 extends Component {
    render() {
        return (
            <View>
                <Text style={styles.remarks}>
                    {
                        "1.	How can I know I have to use id instead of the code?"
                    }
                </Text>
                <Text style={styles.remarks}>
                    {
                        "You can check by Data Dictionary. All fields with Lookup value are storing the reference id."
                    }
                </Text>
                <Image source={images.ch3_fig8} style={{ width: 1021, height: 187 }} />
            </View>
        )
    }
}

const styles = StyleSheet.create({
    remarks: {
        width: 680,
        borderWidth: 1,
        paddingTop: 20,
    },
    text: {
        margin: 6,
        backgroundColor: 'transparent',
        fontSize: 10
    },
});

export default Faq1;



// WEBPACK FOOTER //
// ./src/pages/ch3/Faq.js